import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import * as DateTypes from 'common-lib';
import moment_ from 'moment';
const moment = moment_;
declare var $: any;

// TODO: Move this component into common-lib - is currently used for Meeting Type Edit and Wizard-Date-Range
@Component({
    selector: 'common-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit {
    @Input() dateRange: DateTypes.DateRange = {
        type: 'fixed-dates',
        start: moment().format(),
        end: moment().add(3, 'weeks').format()
    };
    /** default behaviour, showing list of pre-defined ranges (meeting type-level only) */
    @Input() timeFrames: { name: string; value: string }[] = [];
    @Input() hideDateRangeOptions = false;
    /** for custom fixed range, with a defined start and end */
    public dateStart = moment().format();
    public dateEnd = moment().add(3, 'weeks').format();
    /** for custom days */
    public customDays = 3;
    @Output() onUpdateDateRange = new EventEmitter<DateTypes.DateRange>();
    @Output() onUpdateDateRangeMode = new EventEmitter<DateTypes.DateRangeMode>();
    public dateRangeMode?: DateTypes.DateRangeMode | string = undefined;

    constructor() {}

    ngOnInit() {
        this.getDates(this.dateRange);
    }

    ngAfterViewInit() {
        if (!this.hideDateRangeOptions) this.initSemanticDropdown('date-range-selector');
    }

    /** We use ngOnChanges specifically for when the meeting type is changed in the Wizard, sending a new dateRange */
    ngOnChanges(changes: { dateRange: SimpleChange }) {
        if (changes.dateRange) {
            this.getDates(changes.dateRange.currentValue);
        }
    }

    /** Handles rendering either a list of pre-determined time frames, or custom options that expand to show more inputs */
    private updateDateRangeMode(mode: DateTypes.DateRangeMode | string) {
        this.dateRangeMode = mode;
        if (mode === 'fixed-dates' || mode === 'days') this.onUpdateDateRangeMode.emit(mode);
    }

    public handleChangeDateRangeMode(mode: DateTypes.DateRangeMode) {
        this.updateDateRangeMode(mode);
        switch (mode) {
            case DateTypes.FixedDatesDateRangeType:
                this.handleUpdateFixedDates({ start: this.dateStart, end: this.dateEnd });
                break;
            case DateTypes.DaysDateRangeType:
                this.handleUpdateCustomDays(this.customDays);
                break;
            default:
                this.handleSelectTimeFrame(this.timeFrames[0]);
                break;
        }
    }

    private initSemanticDropdown(elementId: 'date-range-selector') {
        setTimeout(() => {
            $(`#${elementId}`).dropdown();
        }, 0);
    }

    private getDates(dateRange: DateTypes.DateRange) {
        switch (dateRange.type) {
            case DateTypes.FixedDatesDateRangeType:
                this.dateStart = dateRange.start;
                this.dateEnd = dateRange.end;
                this.updateDateRangeMode(dateRange.type);
                break;
            case DateTypes.DaysDateRangeType:
                this.customDays = dateRange.days;
                this.updateDateRangeMode(dateRange.type);
                break;
            case DateTypes.TextDateRangeType:
                this.dateRangeMode = undefined;
                this.updateDateRangeMode(dateRange.text);
            default:
                this.dateRangeMode = undefined;
                this.updateDateRangeMode(dateRange.text);
                break;
        }
    }

    private updateDateRange(dateRange: DateTypes.DateRange) {
        this.onUpdateDateRange.emit(dateRange);
    }

    public handleSelectTimeFrame(timeFrame: { name: string; value: string }) {
        this.updateDateRange({ type: 'text', text: timeFrame.value });
    }

    public handleUpdateFixedDates(fixedDates: { start: string; end: string }) {
        // convert start to startOf day and end to endOf day
        const startDate = moment(fixedDates.start).startOf('day').format();
        const endDate = moment(fixedDates.end).endOf('day').format();
        this.updateDateRange({ type: 'fixed-dates', start: startDate, end: endDate });
    }

    public handleUpdateCustomDays(days: number) {
        this.updateDateRange({ type: 'days', days });
    }
}
